const photos = {
    empanadas1: '../images/Poppi/empanadas1.jpeg',
    pizza1: '../images/Poppi/pizza1.jpeg',
    pizza2: '../images/Poppi/pizza2.jpeg',
    pizza3: '../images/Poppi/pizza3.jpeg',
}

const Poppi = {
    id: 9,
    nombre: 'Poppi',
    foto: '',
    desc: 'Pizzas y Empanadas',
    userInsta: '',
    idFace: '',
    numWpp: '',
    carta: {
        pizzas: [
            {
                id: 0,
                nombre: 'Napolitana',
                foto: photos.pizza1,
                desc: 'Pizza de napolitana',
                precio: '$$$$',
            },
            {
                id: 1,
                nombre: 'Roquefort',
                foto: photos.pizza2,
                desc: 'Pizza de roquefort',
                precio: '$$$$',
            },
            {
                id: 2,
                nombre: 'Anchoas',
                foto: photos.pizza3,
                desc: 'Pizza de anchoas',
                precio: '$$$$',
            },
            {
                id: 3,
                nombre: 'Huevo',
                foto: photos.pizza1,
                desc: 'Pizza de huevo',
                precio: '$$$$',
            },
            {
                id: 4,
                nombre: 'Jamon y morron',
                foto: photos.pizza2,
                desc: 'Pizza de Jamon y morron',
                precio: '$$$$',
            },
            {
                id: 5,
                nombre: 'Vegetales',
                foto: photos.pizza3,
                desc: 'Pizza de Vegetales',
                precio: '$$$$',
            },
            {
                id: 6,
                nombre: 'Rúcula',
                foto: photos.pizza1,
                desc: 'Pizza de Rúcula',
                precio: '$$$$',
            },
            {
                id: 7,
                nombre: 'Champiñones',
                foto: photos.pizza2,
                desc: 'Pizza de Champiñones',
                precio: '$$$$',
            },
            {
                id: 8,
                nombre: 'Calabresa',
                foto: photos.pizza3,
                desc: 'Pizza de Calabresa',
                precio: '$$$$',
            },
            {
                id: 9,
                nombre: 'Palmitos',
                foto: photos.pizza1,
                desc: 'Pizza de Palmitos',
                precio: '$$$$',
            },
        ],
        empanadas: [
            {
                id: 0,
                nombre: 'Carne',
                foto: photos.empanadas1,
                desc: 'Descripcion Carne',
                precio: '$$$$',
            },
            {
                id: 1,
                nombre: 'Pollo',
                foto: photos.empanadas1,
                desc: 'Descripcion Pollo',
                precio: '$$$$',
            },
            {
                id: 2,
                nombre: 'Capresse',
                foto: photos.empanadas1,
                desc: 'Descripcion Capresse',
                precio: '$$$$',
            },
            {
                id: 3,
                nombre: 'Jamón y queso',
                foto: photos.empanadas1,
                desc: 'Descripcion Jamón y queso',
                precio: '$$$$',
            },
            {
                id: 4,
                nombre: 'Vegetales',
                foto: photos.empanadas1,
                desc: 'Descripcion Vegetales',
                precio: '$$$$',
            },
        ],
        ensaladas: [
            {
                id: 0,
                nombre: 'Ensalada 1',
                foto: '',
                desc: 'Descripcion Ensalada 1',
                precio: '$$$$',
            },
            {
                id: 1,
                nombre: 'Ensalada 2',
                foto: '',
                desc: 'Descripcion Ensalada 2',
                precio: '$$$$',
            },
        ],
        papas: [
            {
                id: 0,
                nombre: 'Papas 1',
                foto: '',
                desc: 'Descripcion Papas 1',
                precio: '$$$$',
            },
            {
                id: 1,
                nombre: 'Papas 2',
                foto: '',
                desc: 'Descripcion Papas 2',
                precio: '$$$$',
            },
        ],
        postres: [
            {
                id: 0,
                nombre: 'Tiramisu',
                foto: '',
                desc: 'Descripcion Tiramisu',
                precio: '$$$$',
            },
            {
                id: 1,
                nombre: 'Chocotorta',
                foto: '',
                desc: 'Descripcion Chocotorta',
                precio: '$$$$',
            },
            {
                id: 2,
                nombre: 'Cheesecake',
                foto: '',
                desc: 'Descripcion Cheesecake',
                precio: '$$$$',
            },
            {
                id: 3,
                nombre: 'Flan casero',
                foto: '',
                desc: 'Descripcion Flan casero',
                precio: '$$$$',
            },
        ],
    },
}

export default Poppi
